import { LuExternalLink } from 'react-icons/lu'

import { Sidebar, SidebarContent, useSidebar } from '@/components/ui/sidebar'
import products from '@/config/products'
import { cn } from '@/utils/cn'

import DevEnvWarning from './components/DevEnvWarning'
import Navigation from './components/Navigation'
import OperationsDisclaimer from './components/OperationsDisclaimer'

const enabledProducts = products.filter(
  (p) => !p.hidden && !p.comingSoon && p.url,
)

const NavigationSidebar = ({ className }: { className?: string }) => {
  const { isMobile } = useSidebar()

  return (
    <Sidebar
      collapsible='offcanvas'
      variant='inset'
      className={cn(
        'sidebar-gradient-background border-elements-dark-dimmed border-r px-2',
        className,
      )}
    >
      <SidebarContent className='sidebar-gradient-background pb-4'>
        <Navigation />

        <div className='mt-auto space-y-2'>
          <DevEnvWarning />
          <OperationsDisclaimer />
        </div>

        {isMobile && enabledProducts.length > 0 && (
          <div className='mt-8'>
            <h3 className='text-elements-dark-contrastText/60 px-3 text-xs font-semibold tracking-wider uppercase'>
              Hubble Universe
            </h3>
            <div className='mt-2 space-y-1'>
              {enabledProducts.map((product) => (
                <a
                  key={product.id}
                  href={product.url ?? '#'}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='text-elements-dark-contrastText/70 hover:bg-elements-dark-dimmed hover:text-elements-dark-contrastText flex items-center gap-2 rounded-md px-2 py-2 text-sm transition-colors'
                >
                  <div
                    className='h-3 w-3 rounded-full'
                    style={{ backgroundColor: product.backgroundColor }}
                  />
                  <span className='flex-1'>{product.name}</span>
                  <LuExternalLink className='text-elements-dark-contrastText/40 h-3 w-3' />
                </a>
              ))}
            </div>
          </div>
        )}
      </SidebarContent>
    </Sidebar>
  )
}

export default NavigationSidebar
